import React, { useState } from 'react'
import acc from './Acc.module.css'
import imgI from '../../../img/new/7.png'
import imgII from '../../../img/new/8.png'
import imgIII from '../../../img/new/6.png'
import imgIV from '../../../img/logo 1.png'
import { FaLinkedin, FaUnlink } from 'react-icons/fa'
import { LuFileSliders } from 'react-icons/lu'
import { MdOutlineDashboard, MdOutlineEmail } from 'react-icons/md'
import { Link } from 'react-router'
import { CiSearch, CiSettings } from 'react-icons/ci'
const AccessPage = () => {

     const [search, setSearch] = useState('')

     const users = [
        { id: 1, name: "Yemi Olakitan", role: "Manager", years: "5 years", accessCode: "90Abc568PomN" },
        { id: 2, name: "Yemi Olakitan", role: "Manager", years: "5 years", accessCode: "90Abc568PomN" },
        { id: 3, name: "Yemi Olakitan", role: "Manager", years: "5 years", accessCode: "90Abc568PomN" },
        { id: 4, name: "Yemi Olakitan", role: "Manager", years: "5 years", accessCode: "90Abc568PomN" },
        { id: 5, name: "Yemi Olakitan", role: "Manager", years: "5 years", accessCode: "90Abc568PomN" }
      ];

  return (
    <div className={acc.acc}>
        <div className={acc.container}>
            <div className={acc.contentI}>
                <img src={imgIV} className={acc.img} alt="" />
            </div>
            <div className={acc.content}>
                <div className={acc.block}>
                    <div className={acc.blocki}>
                            <div className={acc.seci}>
                                <Link to='/Admin/AdminBoard'>
                                <div className={acc.icon}>
                                    <MdOutlineDashboard/>
                                    <h3 >Dashboard</h3>
                                </div>
                                </Link>
                                <Link to='/Admin/AdminBoard/AdminEmploy'>
                                <div className={acc.icon}>
                                    <LuFileSliders  />
                                    <h3 > Employees</h3>
                                </div>
                                </Link  >
                                <Link to='/Admin/AdminBoard/AccessCode'>
                                <div className={acc.icon}>
                                    <LuFileSliders className={acc.word} />
                                    <h3 className={acc.word}>Access Code</h3>
                                </div>
                                </Link>
                            </div>
                            <div className={acc.seciI}>
                                <div className={acc.icon}>
                                    <CiSettings />
                                    <h3>Settings</h3>
                                </div>
                                <Link to='/Admin'>
                            <div className={acc.icon}>                               
                                <h3>Logout</h3>
                            </div>
                            </Link>
                            </div>
                    </div>
                    <div className={acc.blockI}>
                    <div className={acc.flex}>
                        <h3>Employees</h3>
                        <div className={acc.flexI}>
                            <div className={acc.inp}>
                                <input type="search"
                                onChange={(e) => setSearch(e.target.value)}
                                name="" id="" />
                                <CiSearch />
                            </div>
                            <img className={acc.imgi} src={imgI} alt="" />
                        </div>
                    </div>
                    <div className={acc.containerI}>
                        <table className={acc.table}>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Years</th>
                                <th>Access Code</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {users.map((user) => (
                                <tr key={user.id}>
                                <td className={acc.userInfo}>
                                    <img src={`https://i.pravatar.cc/40?img=${user.id}`} alt="avatar" className={acc.avatar} />
                                    {user.name}
                                </td>
                                <td>{user.role}</td>
                                <td>{user.years}</td>
                                <td className={acc.accessCode}>{user.accessCode}</td>
                                <td>
                                    <button className={acc.generateBtn}>Generate new code</button>
                                    <button className={acc.revokeBtn}>Revoke membership</button>
                                </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AccessPage
